import React from "react";
import { useSnackbar } from "notistack";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, Theme } from "@material-ui/core/styles";

interface ISnackbarClose {
	itemKey: string | number | undefined;
}

const useStyles = makeStyles(
	({ palette }: Theme) => ({
		root: {
			color: palette.primary.contrastText
		}
	}),
	{ name: "SnackbarClose" }
);

const SnackbarClose = ({ itemKey }: ISnackbarClose) => {
	const { closeSnackbar } = useSnackbar();
	const classes = useStyles();

	return (
		<IconButton className={classes.root} onClick={() => closeSnackbar(itemKey)}>
			<CloseIcon />
		</IconButton>
	);
};

export default SnackbarClose;
